function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights",
  d: "M93.33,114h69.33a0,0,0,0,1,0,0v66a12,12,0,0,1-12,12H105.33a12,12,0,0,1-12-12V114A0,0,0,0,1,93.33,114Z",
  transform: "translate(256 305.95) rotate(180)"
}), React.createElement("path", {
  className: "highlights",
  d: "M174.67,59.32H232a0,0,0,0,1,0,0V180a12,12,0,0,1-12,12H174.67a12,12,0,0,1-12-12V71.32A12,12,0,0,1,174.67,59.32Z",
  transform: "translate(394.67 251.32) rotate(180)"
}), React.createElement("path", {
  className: "highlights",
  d: "M24,160.78H81.33a12,12,0,0,1,12,12V180a12,12,0,0,1-12,12H36a12,12,0,0,1-12-12V160.78A0,0,0,0,1,24,160.78Z",
  transform: "translate(117.33 352.78) rotate(180)"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M93.33,82.37h69.33a0,0,0,0,1,0,0V180a12,12,0,0,1-12,12H105.33a12,12,0,0,1-12-12V82.37A0,0,0,0,1,93.33,82.37Z",
  transform: "translate(256 274.37) rotate(180)"
}), React.createElement("line", {
  className: "primary",
  x1: 24,
  y1: 224,
  x2: 232,
  y2: 224
}), React.createElement("path", {
  className: "primary",
  d: "M174.67,32H232a0,0,0,0,1,0,0V180a12,12,0,0,1-12,12H174.67a12,12,0,0,1-12-12V44a12,12,0,0,1,12-12Z",
  transform: "translate(394.67 224) rotate(180)"
}), React.createElement("path", {
  className: "primary",
  d: "M24,133H81.33a12,12,0,0,1,12,12v35a12,12,0,0,1-12,12H36a12,12,0,0,1-12-12V133A0,0,0,0,1,24,133Z",
  transform: "translate(117.33 324.97) rotate(180)"
})));
var SvgReports = function SvgReports(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Reports.f2ed6e46.svg";
export { ForwardRef as ReactComponent };